import { render, staticRenderFns } from "./TableOfPoints.vue?vue&type=template&id=1e817520&"
import script from "./TableOfPoints.vue?vue&type=script&lang=js&"
export * from "./TableOfPoints.vue?vue&type=script&lang=js&"
import style0 from "./TableOfPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports